import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

function createData(uid, date, vimeo_id, title, intensity, equipment, duration, trainer, tag, type, link_id, store_sku, draft, col_order, video_key, inFolder) {
  return          { uid, date, vimeo_id, title, intensity, equipment, duration, trainer, tag, type, link_id, store_sku, draft, col_order, video_key, inFolder };
}


const headCells = [
  { id: 'uid', disablePadding: true, label: 'UID' },
  { id: 'date', disablePadding: true, label: 'Date' },
  { id: 'vimeo_id', disablePadding: false, label: 'Vimeo ID' },
  { id: 'title', disablePadding: false, label: 'Title' },
  //{ id: 'description', disablePadding: false, label: 'Description' },
  //{ id: 'intensity', disablePadding: false, label: 'Intensity' },
  //{ id: 'equipment', disablePadding: false, label: 'Equipment' },
  //{ id: 'duration', disablePadding: false, label: 'Duration' },

  { id: 'trainer', disablePadding: false, label: 'Trainer' },
  { id: 'tag', disablePadding: false, label: 'Tag' },
  { id: 'type', disablePadding: false, label: 'Type' },
  { id: 'link_id', disablePadding: false, label: 'Link ID' },

  { id: 'store_sku', disablePadding: false, label: 'Store Sku' },
  //{ id: 'thumbnail', disablePadding: false, label: 'Image' },
  { id: 'draft', disablePadding: false, label: 'Draft' },
  { id: 'col_order', disablePadding: false, label: 'Column Order' },
  { id: 'video_key', disablePadding: false, label: 'Video' },
  { id: 'inFolder', disablePadding: false, label: 'In Folder?' },
];

let rows = [];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            style={{ backgroundColor: 'grey', color: 'white' }}
            key={headCell.id}
            align={'center'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >

            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};


function checkIfInFolder(level1, level2, level3, folders){
  return 88
}

export function TableWorkouts(props) {

  rows = [];

  for (let i = 0; i < props.data.length; i++) {
    const d = props.data[i];

    //d.inFolder = checkIfInFolder(d.level1, d.level2, d.level3, props.resultsFolderThumbnails);

    rows.push(createData(
      d.uid,
      moment(d.date * 1000).utc().format("DD MMM YYYY"),
      d.vimeo_id,
      d.title,
      //d.description === null ? '' : d.description.substring(0,30),
      d.intensity,
      d.equipment,
      d.duration,
      d.trainer,
      d.tag,
      d.type,
      d.link_id,
      d.store_sku ? d.store_sku : '-',
      //d.thumbnailUrl ? 'Yes' : 'Missing',
      d.draft ? 'Yes' : 'No',
      d.col_order,
      d.video_key,
      d.inFolder ? 'Yes' : 'No',
    ));
  }


  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.uid);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (uid) => selected.indexOf(uid) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>

        <TableContainer>
          <Table
            style={{ width: "auto", tableLayout: "auto" }}
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.uid);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      //onClick={(event) => handleClick(event, row.uid)}
                      onClick={()=>props.rowPressed(row.uid)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.uid}
                      selected={isItemSelected}
                    >

                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="center" component="th" id={labelId} scope="row" padding="none">{row.uid}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.date}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.vimeo_id}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.title}</TableCell>
                      {/*
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.description}</TableCell>
                      */}
                        {/*
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.intensity}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.equipment}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.duration}</TableCell>
                        */}
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.trainer}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.tag}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.type}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.link_id}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.store_sku}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.draft}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.col_order}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.video_key}</TableCell>
                      <TableCell style={{ fontSize: 12 }} colSpan='1' align="left">{row.inFolder}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage} //onChangePage
          onRowsPerPageChange={handleChangeRowsPerPage} //onChangeRowsPerPage
        />
      </Paper>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));
